import { useState, useCallback, useEffect } from 'react';
import { Account, SelectItemProps } from '@ui/src';
import { useLazyGetReportsTransactionsAccountsQuery } from '../service';

interface ListResponse {
  data: { data: { edges: { node: Account }[] } };
}

let timeout: NodeJS.Timeout;

const useGetAutocompleteList = () => {
  const [autocompleteList, setAutocompleteList] = useState<SelectItemProps[]>(
    [],
  );

  const [getList, { isFetching, isLoading }] =
    useLazyGetReportsTransactionsAccountsQuery();

  const getAutocompleteListAction = useCallback(async (query?: string) => {
    const results: SelectItemProps[] = [];

    const response = (await getList(
      `?take=40${query ? `&search=${query}` : ''}`,
    )) as ListResponse;

    if (response?.data?.data) {
      response.data.data.edges?.forEach((item) => {
        results.push({
          name: item.node.clientName,
          description: item.node.description,
          value: item.node.id,
          suffix: item.node.fullNumber,
        });
      });
    }

    setAutocompleteList(results);
  }, []);

  const onSearch = (query: string) => {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      getAutocompleteListAction(query);
    }, 300);
  };

  useEffect(() => {
    getAutocompleteListAction();
  }, [getAutocompleteListAction]);

  return {
    getAutocompleteListAction,
    autocompleteList,
    onSearch,
    isLoading: isLoading || isFetching,
  };
};

export default useGetAutocompleteList;
